module.exports = __webpack_public_path__ + "static/img/my.5e5234a5.png";